import React, {useEffect, useState} from 'react';
import {ScrollView, View} from 'react-native';

import Icon from '/component/base/Icon';
import BasePopover from '/component/base/Popover';
import RadioButtonGroup from '/component/base/RadioButton/RadioButtonGroup';
import Text from '/component/base/Text';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import {DownlineProfile} from '/constant/TestIDs';
import {EVENT_NAMES, USER_TYPES} from '/enum/tealium.enum';
import {generateCallback} from '/util/component.util';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import testProperties from '/util/testing/testProperties';

import {styles} from './DispositionPopover.style';

export type reasonCodes = {
  dispositionTypeId: string;
  dispositionDescription: string;
};
interface DispositionPopoverProps {
  popoverClose: () => void;
  dispositionOptionArray: reasonCodes[];
  getDispositionOptions: any;
  saveDispositionData: () => void;
  dispositionTypeId: any;
  candidateId: any;
  dispositionDescription: any;
  lastPaidRank: string;
  highestAchievedRank: string;
  coachId: string;
}

export const DispositionPopover = (props: DispositionPopoverProps) => {
  const {
    popoverClose,
    dispositionOptionArray,
    dispositionTypeId,
    saveDispositionData,
    candidateId,
    dispositionDescription,
    lastPaidRank,
    highestAchievedRank,
    coachId,
  } = props;
  const [selectedValue, setSelectedValue] = useState(dispositionTypeId);
  const [saveDisable, setsaveDisable] = useState(false);
  const handleSelect = (value: React.SetStateAction<null>) => {
    setSelectedValue(value);
  };

  const Array = dispositionOptionArray?.map((item: any) => ({
    text: item?.dispositionDescription,
    selected: item?.dispositionTypeId === selectedValue,
    onPress: () => {
      handleSelect(item?.dispositionTypeId);
      setsaveDisable(true);
    },
  }));

  // Find the selected item's description
  const selectedDescription = dispositionOptionArray?.find(
    item => item?.dispositionTypeId === selectedValue,
  )?.dispositionDescription;

  const formattedText = selectedDescription
    ?.toUpperCase()
    .replace(/[\s/]/g, '_');

  useEffect(() => {
    if (dispositionDescription === selectedDescription) {
      setsaveDisable(false);
    }
  }, [selectedDescription]);

  const saveCandidateProfileData = ({selectedValue}: any) => {
    return {
      dispositionTypeId: selectedValue,
      dispositionDescription: selectedDescription,
    };
  };

  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.disposition,
  });
  const generateOnDispositionPress = generateCallback({
    func: sendEvent,
    params: {
      userType: USER_TYPES.candidate,
      userId: candidateId,
      newDisposition: formattedText,
      lastPaidRank: lastPaidRank,
      coachHighestRank: highestAchievedRank,
      coachId: String(coachId),
    },
  });
  const UpdateDisposition = () => {
    const candidateProfileData = saveCandidateProfileData({
      selectedValue,
    });
    saveDispositionData(candidateId, candidateProfileData);
    generateOnDispositionPress();
    popoverClose();
  };

  return (
    <KeyboardAvoidingView>
      <ScrollView keyboardShouldPersistTaps="always">
        <BasePopover padded>
          <View style={styles.modalHeader}>
            <Text
              style={styles.marginTop}
              onPress={popoverClose}
              {...testProperties('close', true)}>
              <Icon name="close" />
            </Text>
            <Text
              style={styles.headerText}
              isBold
              {...testProperties(DownlineProfile.dispositionOptionsHeader)}>
              Options
            </Text>
            {saveDisable ? (
              <Text
                style={styles.saveText}
                onPress={UpdateDisposition}
                isBold
                {...testProperties(DownlineProfile.dispositionOptionsSave)}>
                Save
              </Text>
            ) : (
              <Text
                style={styles.saveTextDisable}
                isBold
                {...testProperties(DownlineProfile.dispositionOptionsSave)}>
                Save
              </Text>
            )}
          </View>
          <View style={styles.radioButtonsContainer}>
            <RadioButtonGroup title={'Dispositions'} options={Array} />
          </View>
        </BasePopover>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};
